import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import { AddContextualData } from '@opendoor/observability/slim';

type PdpAnalyticsProps = PropsWithChildren<{
  addressId: string;
  refreshed: boolean;
  preview: boolean;
}>;

export const PdpAnalytics = ({ addressId, refreshed, preview, children }: PdpAnalyticsProps) => {
  const context = useMemo(() => {
    const version = refreshed ? 'v2' : 'v1';
    return {
      data: { pdpVersion: version, pdpPreview: preview, pdpAddressUuid: addressId },
      propertyPageContext: { version, preview, addressUuid: addressId },
    };
  }, [addressId, refreshed, preview]);

  return <AddContextualData {...context}>{children}</AddContextualData>;
};
